<template>
  <div class="row" style="padding: 30px;">
    <div class="col-12" v-if="success">
      <div class="row" style="margin-top: 75px">
        <div class="col-12 center">
          <h2 class="teal-text">Success!</h2>
          <p>The reservation has been register.</p>
          <button
            @click="closeModal"
            style="margin-top: 20px"
            class="waves-effect waves-light teal btn-small btn-block"
          >Sluiten</button>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="!success">
      <div class="row">
        <div class="col-12">
          <h5>Making A Booking | {{ selectedOffice.naam }}</h5>
        </div>
      </div>
      <div class="row margin-top-30">
        <div class="col-12">
          <h5 class="teal-text">{{ day }}</h5>
          <p class="grey-text">{{ time }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for>E-Mail</label>
          <input type="text" v-model="email_employee" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for>Name</label>
          <input type="text" v-model="name_employee" />
        </div>
      </div>
      <div class="row margin-top-30">
        <div class="col-12">
          
          <div class="row center">
              <div class="col m4">
                <button type="button" class="waves-effect waves-light btn btn-block" :class="{ grey: shift != 1 }" @click.prevent="shift = 1" :disabled="disabled_day">Whole Day</button>
              </div>
               <div class="col m4">
                 <button type="button" class="waves-effect waves-light btn btn-block" :class="{ grey: shift != 2 }" @click.prevent="shift = 2" :disabled="disabled_morning">Morning</button>
              </div>
               <div class="col m4">
                 <button type="button" class="waves-effect waves-light btn btn-block" :class="{ grey: shift != 3 }" @click.prevent="shift = 3" :disabled="disabled_afternoon">Afternoon</button>
              </div>
          </div>
        </div>
      </div>
      <div class="row margin-top-20">
        <div class="col-12">
          <button type="button" class="waves-effect waves-light btn" @click.prevent="confirmBooking()">Confirm Reservation</button>
        </div>
      </div>
      <div class="row" v-if="feedback">
        <div class="col-12">
          <p class="red-text">{{ feedback }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addBooking from "@/components/modals/addSecretaryBooking";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import firebase from "firebase";
export default {
  name: "addSecretaryBooking",
  data() {
    return {
      name_employee: null,
      email_employee: null,
      shift: null,
      disabled_day: false,
      disabled_afternoon: false,
      disabled_morning: false,
      time: null,
      day: null,
      feedback: null,
      success: false,
      user: null,
    };
  }, 
  props: ["office_id", "timestamp", "shifts_possible"],
  computed: {
    ...mapGetters(["selectedOffice"]),
  },
  methods: {
    ...mapActions(["createSecretaryBooking"]),
    confirmBooking() {
      if (this.user.permission < 200) {
        this.feedback =
          "You do not have sufficient permission to complete this booking.";
      } else {
        if (this.name_employee && this.email_employee && this.shift) {
          let info = {
            officeid: this.office_id,
            employee: this.name_employee,
            email: this.email_employee.toLowerCase(),
            timestamp: this.timestamp,
            location: this.selectedOffice.naam,
            shift: this.shift,
          };
          this.createSecretaryBooking(info);
          this.success = true;
        } else {
          this.feedback = "You must provide a name, email and a shift.";
        }
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
  created() {
    this.shift = this.shifts_possible;
    if(this.shifts_possible == 3){
      this.disabled_day = true;
      this.disabled_morning = true;
    } else if (this.shifts_possible == 2) {
      this.disabled_day = true;
      this.disabled_afternoon = true;
    }
    this.time = moment(this.timestamp).format("Do MMM");
    this.day = moment(this.timestamp).format("dddd");
    this.user = firebase.auth().currentUser;
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/modals/addSecretaryBooking.vue